import noticeList from './notice-list.vue'

export default noticeList
